"use strict";

// Font Awesome CDN loading
document.write('<script src="https://use.fontawesome.com/36bd8309ab.js"></script>');
//


function writeHeader() {

    var xhr = new XMLHttpRequest();
    xhr.open("GET", "parts_header_common.html", false);
    xhr.send(null);
    if (xhr.status === 200) {
        document.write(xhr.responseText);
    } else if (xhr.status === 404) {
        document.write("404<br>Not Found");
    }

    // $.ajax({
    //     // url: rootDir + "parts_header_common.html",
    //     url: "parts_header_common.html",
    //     cache: false,
    //     async: false
    // }).done(function (data) {
    //     document.write(data);
    // }).fail(function (data) {
    //     document.write("error");
    // });
}

function writeNav() {

    var xhr = new XMLHttpRequest();
    xhr.open("GET", "parts_nav_common.html", false);
    xhr.send(null);
    if (xhr.status === 200) {
        document.write(xhr.responseText);
    } else if (xhr.status === 404) {
        document.write("404<br>Not Found");
    }

    // $.ajax({
    //     // url: rootDir + "parts_header_common.html",
    //     url: "parts_nav_common.html",
    //     cache: false,
    //     async: false
    // }).done(function (data) {
    //     console.log(document);
    //     document.write(data);
    // }).fail(function (data) {
    //     document.write("error");
    // });
}

// メニュー

function writeAsideVisitorHospitalization() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_visitor_hospitalization.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeAsideAboutHospital() {

    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_about_hospital.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
        // document.createElement(data);
        // document.createTextNode(data);


        // var s = document.createElement("script");
        // s.innerHTML = "alert(123)";
        //
        // var ele = document.getElementById("abc");
        // ele.appendChild(s);

        // document.appendChild(data);

    }).fail(function (data) {
        document.write("error");
    });
}

function writeAsideDept() {

    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_dept.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
        // document.createElement(data);
        // document.createTextNode(data);


        // var s = document.createElement("script");
        // s.innerHTML = "alert(123)";
        //
        // var ele = document.getElementById("abc");
        // ele.appendChild(s);

        // document.appendChild(data);

    }).fail(function (data) {
        document.write("error");
    });
}

function writeAsideAboutHospitalTTT(tgtId) {

    // ID要素がない場合はなにもしない
    if (document.getElementById(tgtId) === null) {
        return false;
    }

    // データを取得して表示する
    var partsFileName = "parts_aside_about_hospital.html";
    var xhr = new XMLHttpRequest();
    xhr.open("GET", partsFileName, true);
    xhr.responseType = "text";
    xhr.onload = function (e) {
        if (xhr.readyState === 4 & xhr.status === 200) {
            document.getElementById(tgtId).innerHTML = xhr.responseText;
        } else if (xhr.status === 404) {
            // document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = "404<br>Not found";
            document.getElementById(tgtId).innerHTML = "404<br>Not found";
        }
    };

    xhr.send(null);
}

function writeAsideMedicalPersonanel() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_medical_personnel.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeAsiderecruitInfo() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_recruit_info.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeAsideInformation() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_information.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeAsideInquery() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_inquery.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeAsideSomethingelse() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_aside_somethingelse.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeBreadcrumbs() {

    var hoge = function hoge() {
        var title = document.getElementsByClassName("main_contents")[0].getElementsByTagName("h1")[0].innerHTML;
        document.title = title + ' | 習志野第一病院';

        var deptName = void 0;
        if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'vh') {
            deptName = "来院･入院の方へ";
        } else if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'md') {
            deptName = "医療関係の方へ";
        } else if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'rc') {
            deptName = "採用情報";
            title = document.getElementsByClassName("main_contents")[0].getElementsByTagName("h2")[0].innerHTML;
        } else if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'in') {
            deptName = "お知らせ";
            title = document.getElementsByClassName("main_contents")[0].getElementsByTagName("h1")[0].innerHTML;
        } else if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'fa') {
            deptName = "お問合せ";
            title = document.getElementsByClassName("main_contents")[0].getElementsByTagName("h1")[0].innerHTML;
        } else if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'se') {
            deptName = "その他";
            title = document.getElementsByClassName("main_contents")[0].getElementsByTagName("h1")[0].innerHTML;
        } else if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'i_') {
            deptName = "お知らせ";
            title = document.getElementsByClassName("main_contents")[0].getElementsByTagName("h1")[0].innerHTML;
        } else if (window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1).substr(0, 2) === 'co') {
            deptName = "お問合せ";
            title = document.getElementsByClassName("main_contents")[0].getElementsByTagName("h1")[0].innerHTML;
        }

        document.getElementsByClassName("breadcrumbs")[0].innerHTML = "<div class='content-wrap'>" + "<ol>" + "<li><a href='index.html'>HOME</a></li>" + "<li><a href='menu_overview_naraichi.html'>" + deptName + "</a></li>" + "<li>" + title + "</li>" + "</ol>" + "</div>";
    };

    window.addEventListener('load', hoge);
}

function writeBreadcrumbsTTT(tgtId) {

    // ID要素がない場合はなにもしない
    if (document.getElementById(tgtId) === null) {
        return false;
    }

    // データを取得して表示する
    var partsFileName = "parts_breadcrumbs_common.html";
    var xhr = new XMLHttpRequest();
    xhr.open("GET", partsFileName, true);
    xhr.responseType = "text";
    xhr.onload = function (e) {
        if (xhr.readyState === 4 & xhr.status === 200) {
            document.getElementById(tgtId).innerHTML = xhr.responseText;
        } else if (xhr.status === 404) {
            // document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = "404<br>Not found";
            document.getElementById(tgtId).innerHTML = "404<br>Not found";
        }
    };

    xhr.send(null);
}

function writeFooter() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_footer_common.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeGreeting(partsFileName, objThis) {
    var list = document.getElementsByClassName('abcd');
    if (list.length > 0) {
        var tgt = document.getElementsByClassName('greeting');
        var xhr = new XMLHttpRequest();
        xhr.open("GET", partsFileName, true);
        xhr.responseType = "text";
        xhr.onload = function (e) {
            if (xhr.readyState === 4 & xhr.status === 200) {
                tgt[0].innerHTML = xhr.responseText;
                if (objThis.tagName !== undefined) {
                    if (objThis.tagName.toUpperCase() === "LI") {
                        for (var i = 0; i < list.length; i++) {
                            var lis = list[i].getElementsByTagName('li');
                            for (var ii = 0; ii < lis.length; ii++) {
                                if (objThis !== lis[ii]) {
                                    lis[ii].classList.remove('tab-current');
                                } else {
                                    lis[ii].classList.add('tab-current');

                                    var h_url = window.location.pathname + '#' + partsFileName.replace('.html', '');

                                    history.replaceState(null, partsFileName.replace('.html', ''), h_url);
                                }
                            }
                        }
                    }
                }
            }
        };
        xhr.send(null);
    }
}

function writeMainContentTTT(contentId, tgtCInnerHtml) {

    // データを取得して表示する
    var partsFileName = contentId + '.html';
    var xhr = new XMLHttpRequest();
    xhr.open("GET", partsFileName, true);
    xhr.responseType = "text";
    xhr.onload = function (e) {
        if (xhr.readyState === 4 & xhr.status === 200) {
            // document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = xhr.responseText;
            document.getElementById(tgtCInnerHtml).innerHTML = xhr.responseText;

            // document.getElementsByClassName(tgtCInnerHtml)[0].appendChild(xhr.responseText);

            console.log('$(tgtCInnerHtml).append(xhr.responseText);');
            // $(tgtCInnerHtml).appendChild(xhr.responseText);
            // $(tgtCInnerHtml).write=xhr.responseText;


            capoooo();

            // var script = document.createElement('script');
            // script.innerHTML = 'capoooo();';
            // document.getElementById('js_test').appendChild(script);

            // // URLを書き換える
            // var hUrl = window.location.pathname + '?' + contentId
            //
            // history.replaceState(
            //     null,
            //     partsFileName.replace('.html', ''),
            //     hUrl);
        } else if (xhr.status === 404) {
            document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = "404<br>Not found";
        }
    };

    xhr.send(null);
}

function writeDeptTab(tabId, fileName, tgtIdInnerHtml) {
    var list = document.getElementById(tabId).parentNode.childNodes;

    for (var i = 0; i < list.length; i++) {

        var li = list[i];

        if (li.tagName === "LI") {

            if (li.id === tabId) {

                // 選択状態にする
                li.classList.add('tab-current');

                // データを取得して表示する
                var partsFileName = fileName + '.html';
                var xhr = new XMLHttpRequest();
                xhr.open("GET", partsFileName, true);
                xhr.responseType = "text";
                xhr.onload = function (e) {
                    if (xhr.readyState === 4 & xhr.status === 200) {

                        // メインコンテンツの表示
                        document.getElementById(tgtIdInnerHtml).innerHTML = xhr.responseText;

                        // ページタイトルの表示
                        var title = document.getElementById('idDeptName').innerHTML;

                        document.title = title + "| 習志野第一病院";

                        // ページ内タイトルの表示
                        var dispClassDeptName = document.getElementsByClassName('dispClassDeptName');
                        for (var i = 0; i < dispClassDeptName.length; i++) {
                            dispClassDeptName[i].innerHTML = title;
                        }

                        // パンくずリストの表示
                        var bredB = document.getElementById(tabId).innerHTML;
                        // const bredB = document.getElementById(tgtCInnerHtml).getElementsByTagName("article")[0].title;

                        // const breadcrumbs =
                        //     "<a href='index.html'>HOME</a> > <a href='menu_overview_naraichi.html'>習志野第一病院について</a> > <a href=?" + fileName + ">" + title + "</a> > " + bredB;

                        var breadcrumbs = "<ol>" + "<li><a href='index.html'>HOME</a></li>" + "<li><a href='menu_overview_naraichi.html'>習志野第一病院について</a></li>" + "<li>" + title + " - " + bredB + "</li>";

                        document.getElementsByClassName("breadcrumbs")[0].getElementsByClassName("content-wrap")[0].innerHTML = breadcrumbs;

                        // URLを書き換える
                        var hUrl = window.location.pathname + '?' + fileName;

                        history.replaceState(null, partsFileName.replace('.html', ''), hUrl);
                    } else if (xhr.status === 404) {
                        document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = "404<br>Not found";
                    }
                };
                xhr.send(null);
            } else {

                // 非選択状態にする
                li.classList.remove('tab-current');
            }
        }
    }
}

/***
 *
 * @param {string} dataId タブのIDおよび表示HTMLファイル名
 * @param {string} displayId 表示先のID
 */
function hogehoge(dataId, displayId) {

    var returnValue;

    var list = document.getElementById(dataId).parentNode.childNodes;

    for (var i = 0; i < list.length; i++) {

        var li = list[i];

        if (li.tagName === "LI") {

            if (li.id === dataId) {

                console.log("ooo: %s", i);

                // 選択状態にする
                li.classList.add('tab-current');

                // データを取得して表示する
                // 同期
                var partsFileName = dataId + '.html';
                var xhr = new XMLHttpRequest();
                xhr.open("GET", partsFileName, false);
                xhr.send(null);

                if (xhr.status === 200) {

                    // メインコンテンツの表示
                    document.getElementById(displayId).innerHTML = xhr.responseText;

                    // ページタイトルの表示
                    var title = document.getElementById('idDeptName').innerHTML;

                    returnValue = title;

                    document.title = title + "| 習志野第一病院";

                    // ページ内タイトルの表示
                    var dispClassDeptName = document.getElementsByClassName('dispClassDeptName');
                    for (var ii = 0; ii < dispClassDeptName.length; ii++) {
                        dispClassDeptName[ii].innerHTML = title;
                    }

                    // パンくずリストの表示
                    var bredB = document.getElementById(dataId).innerHTML;

                    var breadcrumbs = "<ol>" + "<li><a href='index.html'>HOME</a></li>" + "<li><a href='menu_dept_list.html'>診療科・部門一覧</a></li>" + "<li>" + title + " - " + bredB + "</li>";

                    document.getElementsByClassName("breadcrumbs")[0].getElementsByClassName("content-wrap")[0].innerHTML = breadcrumbs;

                    // URLを書き換える
                    var hUrl = window.location.search.substr(0, window.location.search.lastIndexOf('?')) + '?' + dataId;

                    history.replaceState(null, partsFileName.replace('.html', ''), hUrl);
                } else if (xhr.status === 404) {
                    document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = "404<br>Not found";
                }

                // データを取得して表示する
                // 非同期
                // var partsFileName = dataId + '.html';
                // var xhr = new XMLHttpRequest();
                // xhr.open("GET", partsFileName, true);
                // xhr.responseType = "text";
                // xhr.onload = function (e) {
                //     if (xhr.readyState === 4 & xhr.status === 200) {
                //
                //         // メインコンテンツの表示
                //         document.getElementById(displayId).innerHTML = xhr.responseText;
                //
                //         // ページタイトルの表示
                //         const title = document.getElementById('idDeptName').innerHTML;
                //
                //         document.title = title + "| 習志野第一病院";
                //
                //         // ページ内タイトルの表示
                //         const dispClassDeptName = document.getElementsByClassName('dispClassDeptName');
                //         for (var ooo = 0; ooo < dispClassDeptName.length; ooo++) {
                //             dispClassDeptName[ooo].innerHTML = title;
                //         }
                //
                //         // パンくずリストの表示
                //         const bredB = document.getElementById(dataId).innerHTML;
                //
                //         const breadcrumbs = "<ol>" +
                //             "<li><a href='index.html'>HOME</a></li>" +
                //             "<li><a href='menu_overview_naraichi.html'>習志野第一病院について</a></li>" +
                //             "<li>" + title + " - " + bredB + "</li>";
                //
                //         document.getElementsByClassName("breadcrumbs")[0].getElementsByClassName("content-wrap")[0].innerHTML = breadcrumbs;
                //
                //         // URLを書き換える
                //         var hUrl = window.location.search.substr(0, window.location.search.lastIndexOf('?')) + '?' + dataId
                //
                //         history.replaceState(
                //             null,
                //             partsFileName.replace('.html', ''),
                //             hUrl);
                //
                //     } else if (xhr.status === 404) {
                //         document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = "404<br>Not found";
                //     }
                // };
                // xhr.send(null);

            } else {

                // 非選択状態にする
                li.classList.remove('tab-current');
            }
        }
    }

    return returnValue;
}

function writeTab(tabId, tgtCInnerHtml) {

    var list = document.getElementById(tabId).parentNode.childNodes;

    for (var i = 0; i < list.length; i++) {

        var li = list[i];

        if (li.tagName === "LI") {

            if (li.id === tabId) {

                // 選択状態にする
                li.classList.add('tab-current');

                // データを取得して表示する
                var partsFileName = tabId + '.html';
                var xhr = new XMLHttpRequest();
                xhr.open("GET", partsFileName, true);
                xhr.responseType = "text";
                xhr.onload = function (e) {
                    if (xhr.readyState === 4 & xhr.status === 200) {

                        // メインコンテンツの表示
                        document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = xhr.responseText;

                        // ページタイトルの表示
                        var title = document.body.title;
                        document.title = title + "| 習志野第一病院";

                        // パンくずリストの表示
                        var bredB = document.getElementsByClassName(tgtCInnerHtml)[0].getElementsByTagName("article")[0].title;
                        var fileName = window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1);
                        var breadcrumbs = "<a href='index.html'>HOME</a> > <a href=" + fileName + ">" + title + "</a> > " + bredB;
                        document.getElementsByClassName("breadcrumbs")[0].getElementsByClassName("content-wrap")[0].innerHTML = breadcrumbs;

                        // URLを書き換える
                        var hUrl = window.location.pathname + '?' + tabId;

                        history.replaceState(null, partsFileName.replace('.html', ''), hUrl);
                    } else if (xhr.status === 404) {
                        document.getElementsByClassName(tgtCInnerHtml)[0].innerHTML = "404<br>Not found";
                    }
                };
                xhr.send(null);
            } else {

                // 非選択状態にする
                li.classList.remove('tab-current');
            }
        }
    }
}

// Object.prototype.values = function () {
//     var o = this;
//     var r = [];
//     for (var k in o) if (o.hasOwnProperty(k)) {
//         r.push(o[k])
//     }
//     return r
// };

// // JSON配列を指定のキーで集計する
// Array.prototype.groupBy = function (keys, sumKeys) {
//     var hash = this.reduce(function (res, data) {
//         // 集計キーを作成
//         var key = keys.reduce(function (s, k) {
//             s += data[k];
//             return s;
//         }, '');
//         // 初めての集計キー
//         if (!(key in res)) {
//             // 集計キーをオブジェクトに設定
//             var keyList = keys.reduce(function (h, k) {
//                 h[k] = data[k];
//                 return h;
//             }, {});
//             // 集計項目の初期値を設定
//             res[key] = sumKeys.reduce(function (h, k) {
//                 h[k] = 0;
//                 return h;
//             }, keyList);
//         }
//         // データを集計（加算）
//         sumKeys.forEach(function (k) {
//             res[key][k] += data[k];
//         });
//
//         return res;
//     }, {});
//
//     return hash.values();
// };

var writeScheduleAll = function writeScheduleAll(idNames) {
    var partsFileName = 'db/' + tb_dept_schedule.tbName;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", partsFileName, true);
    xhr.responseType = "json";
    xhr.onload = function (e) {
        if (xhr.readyState === 4 & xhr.status === 200) {

            var dataJson = xhr.response;
            var filtered = void 0;

            // ie 11 判定
            if (navigator.userAgent.indexOf('Trident') !== -1) {
                dataJson = JSON.parse(dataJson);
            }

            // 検索する場合
            filtered = dataJson.filter(function (item, index) {
                if (item.dept === deptName & item.ampm === ampm) return true;
            });

            // 取得したデータを文字列にする場合
            var tableText = '';
            for (var i = 0; i < filtered.length; i++) {

                var rowtext = '<div class="Rtable-cell"><div>' + filtered[i][tb_dept_schedule.monday] + '</div></div>' + '<div class="Rtable-cell"><div>' + filtered[i][tb_dept_schedule.tuesday] + '</div></div>' + '<div class="Rtable-cell"><div>' + filtered[i][tb_dept_schedule.wednesday] + '</div></div>' + '<div class="Rtable-cell"><div>' + filtered[i][tb_dept_schedule.thursday] + '</div></div>' + '<div class="Rtable-cell"><div>' + filtered[i][tb_dept_schedule.friday] + '</div></div>' + '<div class="Rtable-cell"><div>' + filtered[i][tb_dept_schedule.saturday] + '</div></div>' + '';

                tableText = tableText + rowtext;
            }

            // 文字列にしたデータをクラスに入れる場合
            var tbHeader = '<div class="Rtable Rtable--6cols">' + '<div class="Rtable-cell Rtable-header">月</div>' + '<div class="Rtable-cell Rtable-header">火</div>' + '<div class="Rtable-cell Rtable-header">水</div>' + '<div class="Rtable-cell Rtable-header">木</div>' + '<div class="Rtable-cell Rtable-header">金</div>' + '<div class="Rtable-cell Rtable-header">土</div>';

            var tbFooter = '<span class="dHeight" hidden></span></div>';

            tableText = tbHeader + tableText + tbFooter;

            document.getElementById(idName).innerHTML = tableText;

            // 高さを<span class="dHeight" hidden></span>に保持する
            console.log('document.getElementById(idName).clientHeight;: %s', document.getElementById(idName).clientHeight);
            document.getElementById(idName).firstElementChild.lastElementChild.innerHTML = document.getElementById(idName).clientHeight;
        } else if (xhr.status === 404) {
            document.getElementById(idName).innerHTML = "404<br>Not found";
        }
    };

    xhr.send(null);
};

/***
 * 医師担当表を作成します。
 * @param {string} deptName 診療科名
 * @param {string} ampm '午前'か'午後'か
 * @param {string} idName 表示したいelementのID
 */
var writeSchedule = function writeSchedule(deptName, ampm, idName) {

    // テーブル列名を定義しておく
    var tb_dept_schedule = {

        tbName: 'tb_dept_schedule.json',
        no: 'no',
        dept: 'dept',
        ampm: 'ampm',
        monday: 'monday',
        tuesday: 'tuesday',
        wednesday: 'wednesday',
        thursday: 'thursday',
        friday: 'friday',
        saturday: 'saturday',
        sunday: 'sunday',
        notes1: 'notes1',
        notes2: 'notes2',
        notes3: 'notes3',
        sortKey1: 'sortKey1',
        sortKey2: 'sortKey2',
        sortKey3: 'sortKey3'
    };

    var partsFileName = 'db/' + tb_dept_schedule.tbName;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", partsFileName, true);
    xhr.responseType = "json";
    xhr.onload = function (e) {
        if (xhr.readyState === 4 & xhr.status === 200) {

            var dataJson = xhr.response;
            var filtered = void 0;

            // ie 11 判定
            if (navigator.userAgent.indexOf('Trident') !== -1) {
                dataJson = JSON.parse(dataJson);
            }

            // 検索する場合
            filtered = dataJson.filter(function (item, index) {
                if (item.dept === deptName & item.ampm === ampm) return true;
            });


            // レスポンシブ 並び替え用
            var orderNum = filtered.length + 1,
                orderBaseMon = 1,
                orderBaseTue = orderBaseMon + orderNum,
                orderBaseWed = orderBaseMon + orderNum * 2,
                orderBaseThu = orderBaseMon + orderNum * 3,
                orderBaseFri = orderBaseMon + orderNum * 4,
                orderBaseSat = orderBaseMon + orderNum * 5;


            // 取得したデータを文字列にする場合
            var tableText = '';
            for (var i = 0; i < filtered.length; i++) {
                // レスポンシブ 並び替え用
                var orderBaseRow = i + 1;

                // var rowtext =
                //     '<div class="Rtable-cell" style="order:' + (orderBaseRow + orderBaseMon) + '"><div>'
                //     + filtered[i][tb_dept_schedule.monday] + '</div></div>' + '' +
                //     '<div class="Rtable-cell" style="order:' + (orderBaseRow + orderBaseTue) + '"><div>'
                //     + filtered[i][tb_dept_schedule.tuesday] + '</div></div>' +
                //     '<div class="Rtable-cell" style="order:' + (orderBaseRow + orderBaseWed) + '"><div>'
                //     + filtered[i][tb_dept_schedule.wednesday] + '</div></div>' +
                //     '<div class="Rtable-cell" style="order:' + (orderBaseRow + orderBaseThu) + '"><div>'
                //     + filtered[i][tb_dept_schedule.thursday] + '</div></div>' +
                //     '<div class="Rtable-cell" style="order:' + (orderBaseRow + orderBaseFri) + '"><div>'
                //     + filtered[i][tb_dept_schedule.friday] + '</div></div>' +
                //     '<div class="Rtable-cell" style="order:' + (orderBaseRow + orderBaseSat) + '"><div>'
                //     + filtered[i][tb_dept_schedule.saturday] + '</div></div>' + '';


                const day_check = (i, day) => {
                    if (filtered[i][tb_dept_schedule[day]] === "") {
                        return ""
                    } else {
                        return `<div>${filtered[i][tb_dept_schedule[day]]}</div>`;
                    }
                };

                const dayOff_check = (i, day) => {
                    if (filtered[i][tb_dept_schedule[day]] === `休診`) {
                        return ` dayOff`
                    } else {
                        return ``;
                    }
                };

                var rowtext = `
                   <div class="Rtable-cell${dayOff_check(i, 'monday')}" style="-webkit-box-ordinal-group:${(orderBaseRow + orderBaseMon)+1};-webkit-order:${(orderBaseRow + orderBaseMon)};-ms-flex-order:${(orderBaseRow + orderBaseMon)};order:${(orderBaseRow + orderBaseMon)}">${day_check(i, 'monday')}</div>
                   <div class="Rtable-cell${dayOff_check(i, 'tuesday')}" style="-webkit-box-ordinal-group:${(orderBaseRow + orderBaseTue)+1};-webkit-order:${(orderBaseRow + orderBaseTue)};-ms-flex-order:${(orderBaseRow + orderBaseTue)};order:${(orderBaseRow + orderBaseTue)}">${day_check(i, 'tuesday')}</div>
                   <div class="Rtable-cell${dayOff_check(i, 'wednesday')}" style="-webkit-box-ordinal-group:${(orderBaseRow + orderBaseWed)+1};-webkit-order:${(orderBaseRow + orderBaseWed)};-ms-flex-order:${(orderBaseRow + orderBaseWed)};order:${(orderBaseRow + orderBaseWed)}">${day_check(i, 'wednesday')}</div>
                   <div class="Rtable-cell${dayOff_check(i, 'thursday')}" style="-webkit-box-ordinal-group:${(orderBaseRow + orderBaseThu)+1};-webkit-order:${(orderBaseRow + orderBaseThu)};-ms-flex-order:${(orderBaseRow + orderBaseThu)};order:${(orderBaseRow + orderBaseThu)}">${day_check(i, 'thursday')}</div>
                   <div class="Rtable-cell${dayOff_check(i, 'friday')}" style="-webkit-box-ordinal-group:${(orderBaseRow + orderBaseFri)+1};-webkit-order:${(orderBaseRow + orderBaseFri)};-ms-flex-order:${(orderBaseRow + orderBaseFri)};order:${(orderBaseRow + orderBaseFri)}">${day_check(i, 'friday')}</div>
                   <div class="Rtable-cell${dayOff_check(i, 'saturday')}" style="-webkit-box-ordinal-group:${(orderBaseRow + orderBaseSat)+1};-webkit-order:${(orderBaseRow + orderBaseSat)};-ms-flex-order:${(orderBaseRow + orderBaseSat)};order:${(orderBaseRow + orderBaseSat)}">${day_check(i, 'saturday')}</div>
                    `;

                tableText = tableText + rowtext;
            }

            // 文字列にしたデータをクラスに入れる場合
            let tbHeader =`
                <div class="Rtable Rtable--6cols">
                <div class="Rtable-cell Rtable-header" style="-webkit-box-ordinal-group:${(orderBaseMon)+1};-webkit-order:${(orderBaseMon)};-ms-flex-order:${(orderBaseMon)};order:${orderBaseMon}">月</div>
                <div class="Rtable-cell Rtable-header" style="-webkit-box-ordinal-group:${(orderBaseTue)+1};-webkit-order:${(orderBaseTue)};-ms-flex-order:${(orderBaseTue)};order:${orderBaseTue}">火</div>
                <div class="Rtable-cell Rtable-header" style="-webkit-box-ordinal-group:${(orderBaseWed)+1};-webkit-order:${(orderBaseWed)};-ms-flex-order:${(orderBaseWed)};order:${orderBaseWed}">水</div>
                <div class="Rtable-cell Rtable-header" style="-webkit-box-ordinal-group:${(orderBaseThu)+1};-webkit-order:${(orderBaseThu)};-ms-flex-order:${(orderBaseThu)};order:${orderBaseThu}">木</div>
                <div class="Rtable-cell Rtable-header" style="-webkit-box-ordinal-group:${(orderBaseFri)+1};-webkit-order:${(orderBaseFri)};-ms-flex-order:${(orderBaseFri)};order:${orderBaseFri}">金</div>
                <div class="Rtable-cell Rtable-header" style="-webkit-box-ordinal-group:${(orderBaseSat)+1};-webkit-order:${(orderBaseSat)};-ms-flex-order:${(orderBaseSat)};order:${orderBaseSat}">土</div>
                `;

            const tbFooter = '<span class="dHeight" hidden></span></div>';

            tableText = tbHeader + tableText + tbFooter;

            document.getElementById(idName).innerHTML = tableText;

            // 高さを<span class="dHeight" hidden></span>に保持する
            console.log('document.getElementById(idName).clientHeight;: %s', document.getElementById(idName).clientHeight);
            document.getElementById(idName).firstElementChild.lastElementChild.innerHTML = document.getElementById(idName).clientHeight;
        } else if (xhr.status === 404) {
            document.getElementById(idName).innerHTML = "404<br>Not found";
        }
    };

    xhr.send(null);
};

function writeInformation() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_information.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeRecreation() {
    $.ajax({
        // url: rootDir + "parts_header_common.html",
        url: "parts_recreation.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}
//# sourceMappingURL=common.js.map